import { useDispatch } from "react-redux";
import { hideAlert, showAlert } from "../../../../../features/slices/applicationSlice";
import { TFunction } from "i18next";

const useAlerts = ({ translate }: { translate: ((key: string) => string) | TFunction }) => {
    const dispatch = useDispatch();

    const showMissingRequiredFieldsAlert = () => {
        dispatch(
            showAlert({
                title: translate('alerts.showMissingRequiredFieldsAlert.title'),
                message: translate('alerts.showMissingRequiredFieldsAlert.message'),
                icon: 'error',
                confirmText: translate('alerts.showMissingRequiredFieldsAlert.confirmText'),
                confirmAction: () => dispatch(hideAlert)
            })
        );
    };

    const showCancelCarcinogenicReportAlert = ({ confirmAction, cancelAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.showCancelCarcinogenicReportAlert.title'),
                message: translate('alerts.showCancelCarcinogenicReportAlert.message'),
                icon: 'info',
                cancelText: translate('alerts.showCancelCarcinogenicReportAlert.cancelText'),
                confirmText: translate('alerts.showCancelCarcinogenicReportAlert.confirmText'),
                cancelAction: cancelAction,
                confirmAction: confirmAction
            })
        );
    };


    return { showMissingRequiredFieldsAlert, showCancelCarcinogenicReportAlert };
};

export default useAlerts;